import * as React from "react";
import {RequestData} from "@models/axios";
import {Card, Form, Button, Icon} from "antd";
import {ReactElement, ReactNode} from "react";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import {notification} from "antd";
import Message from "../constants/message";

interface ModalFormProps {
  className: string;
  toggleButton: ReactElement;
  createRequest: (requestData: RequestData) => any;
  updateRequest: (requestData: RequestData) => any;
  history: object;
  viewOnly:boolean

  // location:object;
}

/**
 * This class render a form inside it ..and handle common method
 * Handles: showModal , hideModal, onSuccess and on error callbacks , call update or create based on id
 * @param Component
 * Gets Error from errorCallback and pass it to the wrapped form to show error message
 * @constructor
 */

const withFormWrapper = <P extends object>(Component: React.ComponentType<P>) =>
  class ModalForm extends React.Component<P & ModalFormProps> {
    state = {
      error: null,
      loading: false
    };

    private formRef?: ReactNode;

    setFormRef = (formRef: ReactNode) => {
      this.formRef = formRef;
    };

    handleError = error => {
      const error_fields = error.data.meta?.fields;
      //TODO inject errors in the form
      this.setState({
        loading: false,
        error_fields
      });
      notification["error"]({
        placement: "bottomLeft",
        duration: 10,
        className: "error-server-side",
        message: this.props.intl.formatMessage({
          id: "app.error",
          defaultMessage: "Error!"
        }),
        description: error.data.meta.message
      });
    };

    /**
     * Gets values form form component and handle create and update request
     * Detect update by checking Id existence in values
     * @param e
     */
    save = successAction => {
      const {payload, id, patch = false} = this.formRef?.getValues();
      if (!payload) {
        console.log("Received error of form: ", payload);
        return;
      }
      this.setState({
        loading: true
      });
      const requestDate = {
        payload: payload,
        patch,
        onSuccessCallback: (data) => {

          this.setState({
            loading: false
          });
          notification["success"]({
            placement: "bottomLeft",
            duration: 2,
            btn: null,
            message: this.props.intl.formatMessage({
              id: "app.save_successfully",
              defaultMessage: Message.Success.Save
            }),
            description: ""
          });

          if (successAction === "back_to_list" && this.props.listUrl) {
            this.props.history.push(this.props.listUrl);
          }
          else if (!id) {
            if(data.id) {
              const editBase = this.props.editPageUrl ?? this.props.listUrl;
              this.props.history.push(`${editBase}/${data.id}/edit`)
            }
            else{
              window.location.reload()
            }
          }
        },
        onErrorCallback: error => this.handleError(error)
      };
      if (id) {
        this.props.updateRequest({
          ...requestDate,
          params: {
            id
          }
        });
      } else {
        this.props.createRequest(requestDate);
      }
    };

    render() {
      const {viewOnly=false} = this.props;

      return (
        <div className={"form-wrapper"}>
          <Card
            actions={ viewOnly ? [] : [
              <Button
                type={"link"}
                className={"cancel-btn"}
                disabled={this.state.loading}
                onClick={() => this.save("back_to_list")}
              >
                <Icon type="rollback"/>
                {"    "}
                <FormattedMessage
                  id="app.save_and_back_to_list"
                  defaultMessage={`Save and back to list`}
                />
              </Button>,
              <Button
                type="link"
                disabled={this.state.loading}
                onClick={() => this.save()}
              >
                <Icon type="save"/>
                {"    "}
                <FormattedMessage id="app.save" defaultMessage={`Save`}/>
              </Button>,

              ...this.props.extraActions || []
            ]}
          >
            <Component
              {...(this.props as P)}
              wrappedComponentRef={this.setFormRef}
              error_fields={this.state.error_fields}
            />
          </Card>
        </div>
      );
    }
  };

export default withFormWrapper;
